import { Injectable } from '@angular/core';
//import { Http, Headers } from '@angular/http';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';

@Injectable()
export class GenericHttpClient {

    constructor(private http: HttpClient) { }

    createAuthorizationHeader(headers: HttpHeaders) {
        headers = new HttpHeaders(
            {
                'Content-type': 'application/json', Authorization: 'Basic ' +
                    window.btoa(sessionStorage.getItem('Login') + ':password')
            });
        return headers;
    }

    get(url, params) {
        let headers = new HttpHeaders();
        headers = this.createAuthorizationHeader(headers);
        return this.http.get(url, {
            headers: headers, params: params
        });
    }

    post(url, data) {
        let headers = new HttpHeaders();
        headers = this.createAuthorizationHeader(headers);
        return this.http.post(url, data, {
            headers: headers
        });
    }
}